/**
 * Sticky Section Titles — Twojeys-style scroll controller
 * Header hide/show only. Top position set by announcement-bar.liquid JS.
 */
(function () {
  if (window.__stickyTitlesInit) return;
  window.__stickyTitlesInit = true;

  var headerWrapper = document.querySelector('.header-wrapper');
  var titleBars = document.querySelectorAll('.collection__title.title-wrapper');
  var stickyEl = document.querySelector('sticky-header');

  if (!headerWrapper) return;

  var THRESHOLD_DOWN = 1;
  var THRESHOLD_UP = 50;
  var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

  window.addEventListener('scroll', function () {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var scrollDirection = scrollTop > lastScrollTop ? 1 : -1;
    var threshold = scrollDirection === 1 ? THRESHOLD_DOWN : THRESHOLD_UP;

    if (scrollTop < 50) {
      headerWrapper.classList.remove('scroll');
      if (stickyEl && stickyEl.isTransparent) {
        headerWrapper.classList.add('header-wrapper--transparent');
      }
      lastScrollTop = scrollTop;
      return;
    }

    if (Math.abs(scrollTop - lastScrollTop) >= threshold) {
      if (scrollDirection === 1) {
        headerWrapper.classList.add('scroll');
        headerWrapper.classList.remove('header-wrapper--transparent');
        if (stickyEl) {
          if (stickyEl.closeMenuDisclosure) stickyEl.closeMenuDisclosure();
          if (stickyEl.closeSearchModal) stickyEl.closeSearchModal();
        }
      } else {
        headerWrapper.classList.remove('scroll');
      }
      lastScrollTop = scrollTop;
    }
  }, { passive: true });

  if (titleBars.length) {
    var barOffset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announce-bar-height')) || 0;
    var stuckObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('is-stuck', entry.intersectionRatio < 1);
      });
    }, { threshold: [1], rootMargin: -(barOffset + 1) + 'px 0px 0px 0px' });
    titleBars.forEach(function (bar) { stuckObserver.observe(bar); });
  }
})();
